import React, { FC, PropsWithChildren } from 'react'
import * as S from './TimelineWidget.styles'

export const TimelineWidget: FC<PropsWithChildren> = ({ children }) => {
  return <S.TimelineWidgetWrapper>{children}</S.TimelineWidgetWrapper>
}
